import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {});
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch((err) => {});
};

Router.prototype.open = function (routeObject) {
  const { href } = this.resolve(routeObject);
  window.open(href, "_blank");
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/CanNotAccess",
      name: "canNotAccess",
      component: () => import("./views/CanNotAccess"),
    },
    {
      path: "/CanNotAccessMerchant",
      name: "canNotAccessMerchant",
      component: () => import("./views/CanNotAccessMerchant"),
    },
    {
      path: "/404",
      name: "pageNotFound",
      component: () => import("./views/PageNotFound"),
    },
    {
      path: "/SessionExpire",
      name: "sessionExpire",
      component: () => import("./views/SessionExpire.vue"),
      meta: {
        description:
          "เข้าสู่ระบบบัญชี PEAK ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft ปลอดภัย หากยังไม่มีบัญชี สมัครใช้งาน PEAK",
      },
    },
    {
      path: "/TooManyRequest",
      name: "tooManyRequest",
      component: () => import("./views/TooManyRequest.vue"),
      meta: {
        description: "ขออภัยครับ คุณมีการใช้งานระบบในปริมาณมาก",
      },
    },
    { path: "*", redirect: "/404" },
    {
      path: "/AcceptInvitation",
      name: "acceptInvitation",
      component: () => import("./views/invitationPage/AcceptInvitation.vue"),
      meta: { title: "PEAK" },
    },
    {
      path: "/AccepInvitationFailPage",
      name: "accepInvitationFailPage",
      component: () => import("./views/invitationPage/AccepInvitationFailPage.vue"),
      meta: { title: "PEAK" },
    },
    {
      path: "/SelectApplication",
      name: "selectApplication",
      redirect: "/",
      meta: { title: "PEAK" },
    },
    {
      path: "/",
      name: "login",
      component: () => import("./views/loginPage/Login"),
      meta: {
        title: "PEAK",
        noindex: false,
        description:
          "เข้าสู่ระบบบัญชี PEAK ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft ปลอดภัย หากยังไม่มีบัญชี สมัครใช้งาน PEAK",
      },
    },
    {
      path: "/logout",
      name: "logout",
      component: () => import("./views/logOutPage/LogOut"),
      meta: { title: "PEAK" },
    },
    {
      path: "/register",
      name: "register",
      component: () => import("./views/registerPage/RegisterPage"),
      children: [
        {
          path: "accountant",
          name: "accountant_register",
          component: () => import("./views/registerPage/contentRegister/DefaultRegister/Accountant"),
          meta: {
            title: "Meta_register",
            noindex: false,
            description:
              "เข้าสู่ระบบบัญชี PEAK ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft ปลอดภัย หากยังไม่มีบัญชี สมัครใช้งาน PEAK",
          },
          props(route) {
            return route.query || {};
          },
        },
        {
          path: "entrepreneur",
          name: "entrepreneur_register",
          component: () => import("./views/registerPage/contentRegister/DefaultRegister/BusinessOwner"),
          meta: {
            title: "Meta_register",
            noindex: false,
            description:
              "เข้าสู่ระบบบัญชี PEAK ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft ปลอดภัย หากยังไม่มีบัญชี สมัครใช้งาน PEAK",
          },
          props(route) {
            return route.query || {};
          },
        },
        {
          path: "trial-function-salesdocuments",
          name: "trial_function_salesdocuments",
          meta: {
            title: "SaleDocRegisterContent.Meta_Page_Title",
            noindex: false,
            description: "SaleDocRegisterContent.Meta_Description",
            propertyOgTitle: "SaleDocRegisterContent.Meta_Page_Title",
            propertyOgDescription: "SaleDocRegisterContent.Meta_Description",
          },
          props(route) {
            return route.query || {};
          },
        },
        {
          path: "trial-function-payroll",
          name: "trial_function_payroll",
          meta: {
            title: "PayrollRegisterContent.Meta_Page_Title",
            noindex: false,
            description: "PayrollRegisterContent.Meta_Description",
            propertyOgTitle: "PayrollRegisterContent.Meta_Page_Title",
            propertyOgDescription: "PayrollRegisterContent.Meta_Description",
          },
          props(route) {
            return route.query || {};
          },
        },
        {
          path: "trial-function-tax",
          name: "trial_function_tax",
          meta: {
            title: "TaxRegisterContent.Meta_Page_Title",
            noindex: false,
            description: "TaxRegisterContent.Meta_Description",
            propertyOgTitle: "TaxRegisterContent.Meta_Page_Title",
            propertyOgDescription: "TaxRegisterContent.Meta_Description",
          },
          props(route) {
            return route.query || {};
          },
        },
        {
          path: "trial-function-accounting-payroll",
          name: "trial-function-accounting-payroll",
          meta: {
            title: "trialFunctionAccountingPayroll.Meta_Page_Title",
            noindex: false,
            description: "trialFunctionAccountingPayroll.Meta_Description",
            propertyOgTitle: "trialFunctionAccountingPayroll.Meta_Page_Title",
            propertyOgDescription: "trialFunctionAccountingPayroll.Meta_Description",
          },
          props(route) {
            return route.query || {};
          },
        },
        {
          path: "from_register",
          name: "from_register",
          component: () => import("./views/registerPage/FormRegisterEmail"),
          meta: {
            title: "Meta_register",
            noindex: false,
            description:
              "เข้าสู่ระบบบัญชี PEAK ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft ปลอดภัย หากยังไม่มีบัญชี สมัครใช้งาน PEAK",
          },
          props(route) {
            return route.query || {};
          },
        },
        {
          path: "sme_register",
          name: "sme_register",
          component: () => import("./views/registerPage/FormRegisterEmail"),
          meta: {
            title: "Meta_register",
            noindex: false,
            description:
              "เข้าสู่ระบบบัญชี PEAK ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft ปลอดภัย หากยังไม่มีบัญชี สมัครใช้งาน PEAK",
          },
          props(route) {
            return route.query || {};
          },
        },
        {
          path: "accountingfirm_register",
          name: "accountingfirm_register",
          component: () => import("./views/registerPage/FormRegisterEmail"),
          meta: {
            title: "Meta_register",
            noindex: false,
            description:
              "เข้าสู่ระบบบัญชี PEAK ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft ปลอดภัย หากยังไม่มีบัญชี สมัครใช้งาน PEAK",
          },
          props(route) {
            return route.query || {};
          },
        },
      ],
    },
    {
      path: "/forgotPwd",
      name: "forgotPwd",
      component: () => import("./views/forgotPasswordPage/ForgotPassword.vue"),
      meta: { title: "Meta_forgotPwd", description: "ลิงก์กำหนดรหัสผ่านใหม่จะถูกส่งไปยังอีเมลผู้ใช้งานของคุณ" },
    },
    {
      path: "/resetPwd",
      name: "resetPwd",
      props: true,
      component: () => import("./views/forgotPasswordPage/SetNewPassword.vue"),
      meta: { title: "Meta_forgotPwd" },
    },
    {
      path: "/welcome",
      name: "welcome",
      component: () => import("./views/welcome/Welcome.vue"),
    },
    {
      path: "/selectlist",
      name: "selectlist",
      component: () => import("./views/selectCompanyPage/SelectList.vue"),
      meta: { title: "Meta_selectlist" },
    },
    {
      path: "/createOrganization",
      name: "createOrganization",
      component: () => import("./views/selectCompanyPage/createOrganization/CreateOrganization.vue"),
      meta: { title: "Meta_selectlist" },
    },
    {
      path: "/createOrganizationDemo",
      name: "createOrganizationDemo",
      component: () => import("./views/selectCompanyPage/createOrganizationDemo/CreateOrganizationDemo.vue"),
      meta: { title: "Meta_selectlist" },
    },
    {
      path: "/emailVerification",
      name: "emailVerification",
      component: () => import("./views/verificationEmail/VerificationEmail.vue"),
      meta: { title: "Verify_Email" },
    },
    {
      path: "/end",
      name: "end",
      component: () => import("./views/logOutPage/End.vue"),
      meta: { title: "Logout_All_Title" },
    },
    {
      path: "/home",
      name: "home",
      component: () => import("./views/peakweb/home/Home.vue"),
      meta: { title: "Menu_home", breadcrumb: [{ name: "Menu_home" }] },
    },
    {
      path: "/onlineview",
      name: "onlineview",
      component: () => import("./views/peakweb/onlineView/OnlineViewPage.vue"),
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import("./views/peakweb/profile/Profile.vue"),
      children: [
        {
          path: "profileSetting",
          name: "profileSetting",
          meta: {
            title: "User_Setting",
            breadcrumb: [{ name: "User_Setting" }],
          },
          component: () => import("./views/peakweb/profile/profileSetting/ProfileSetting.vue"),
        },
        {
          path: "userAccount",
          name: "userAccount",
          meta: {
            title: "User_Account",
            breadcrumb: [{ name: "User_Account" }],
          },
          component: () => import("./views/peakweb/profile/userAccount/UserAccount.vue"),
        },
        {
          path: "merchantList",
          name: "merchantList",
          meta: {
            title: "User_Setting",
            breadcrumb: [{ name: "User_Setting" }],
          },
          component: () => import("./views/peakweb/profile/merchantList/MerchantList.vue"),
        },
      ],
    },
    {
      path: "/help",
      name: "help",
      component: () => import("./views/peakweb/help/Help.vue"),
    },
    {
      path: "/invitation",
      name: "invitation",
      component: () => import("./views/peakweb/invitation/Invitation.vue"),
    },
    {
      path: "/import",
      name: "import",
      meta: { title: "Import" },
      component: () => import("./views/peakweb/import/Import.vue"),
      children: [
        {
          path: "importDocument",
          name: "importDocument",
          meta: {
            title: "Import_Table_Header",
            breadcrumb: [{ name: "Import_Table_Header" }],
          },
          component: () => import("./views/peakweb/import/ImportDocument.vue"),
        },
        {
          path: "importDocumentTemplateDetail",
          name: "importDocumentTemplateDetail",
          meta: {
            title: "Import_Document",
            breadcrumb: [{ name: "Import_Table_Header", linkName: "importDocument" }, { name: "Import_Document" }],
          },
          component: () => import("./views/peakweb/import/ImportDocumentTemplateDetail.vue"),
        },
        {
          path: "importDocumentTemplateCreate",
          name: "importDocumentTemplateCreate",
          meta: {
            title: "Create_Import_Document",
            breadcrumb: [
              { name: "Import_Table_Header", linkName: "importDocument" },
              { name: "Create_Import_Document" },
            ],
          },
          component: () => import("./views/peakweb/import/ImportDocumentTemplateCreate.vue"),
        },
        {
          path: "importDocumentDetail",
          name: "importDocumentDetail",
          meta: {
            breadcrumb: [{ name: "Import_Table_Header", linkName: "importDocument" }],
          },
          component: () => import("./views/peakweb/import/ImportDocumentDetail.vue"),
        },
      ],
    },
    // income Page
    {
      path: "/income",
      name: "income",
      component: () => import("./views/peakweb/income/Income.vue"),
      meta: { title: "Menu_income", breadcrumb: [{ name: "Menu_income" }] },
      children: [
        {
          path: "quotation",
          name: "income_quotation",
          component: () => import("./views/peakweb/income/quotation/Quotation.vue"),
          meta: {
            title: "Menu_quotation",
            breadcrumb: [{ name: "Menu_income", linkName: "income" }, { name: "Menu_quotation" }],
          },
        },
        {
          path: "quotationCreate",
          name: "income_quotationCreate",
          component: () => import("./views/peakweb/income/quotation/QuotationCreate.vue"),
          meta: {
            title: "Menu_quotationCreate",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_quotation", linkName: "income_quotation" },
              { name: "Menu_quotationCreate" },
            ],
          },
        },
        {
          path: "quotationDetail",
          name: "income_quotationDetail",
          component: () => import("./views/peakweb/income/quotation/quotationDetail/QuotationDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_quotation", linkName: "income_quotation" },
            ],
          },
        },
        {
          path: "quotationEdit",
          name: "income_quotationEdit",
          component: () => import("./views/peakweb/income/quotation/quotationEdit/QuotationEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_quotation", linkName: "income_quotation" },
            ],
          },
        },
        {
          path: "deposit",
          name: "income_deposit",
          component: () => import("./views/peakweb/income/deposit/Deposit.vue"),
          meta: {
            title: "Menu_depositReceipt",
            breadcrumb: [{ name: "Menu_income", linkName: "income" }, { name: "Menu_depositReceipt" }],
          },
        },
        {
          path: "depositCreate",
          name: "income_depositCreate",
          component: () => import("./views/peakweb/income/deposit/DepositCreate.vue"),
          meta: {
            title: "Menu_depositReceiptCreate",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_depositReceipt", linkName: "income_deposit" },
              { name: "Menu_depositReceiptCreate" },
            ],
          },
        },
        {
          path: "depositDetail",
          name: "income_depositDetail",
          component: () => import("./views/peakweb/income/deposit/depositDetail/DepositDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_depositReceipt", linkName: "income_deposit" },
            ],
          },
        },
        {
          path: "depositEdit",
          name: "income_depositEdit",
          component: () => import("./views/peakweb/income/deposit/depositEdit/DepositEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_depositReceipt", linkName: "income_deposit" },
            ],
          },
        },
        {
          path: "invoice",
          name: "income_invoice",
          component: () => import("./views/peakweb/income/invoice/Invoice.vue"),
          meta: {
            title: "Menu_invoiceDetail",
            breadcrumb: [{ name: "Menu_income", linkName: "income" }, { name: "Menu_invoiceDetail" }],
          },
        },
        {
          path: "invoiceDetail",
          name: "income_invoiceDetail",
          component: () => import("./views/peakweb/income/invoice/invoiceDetail/InvoiceDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_invoiceDetail", linkName: "income_invoice" },
            ],
          },
        },
        {
          path: "invoiceEdit",
          name: "income_invoiceEdit",
          component: () => import("./views/peakweb/income/invoice/invoiceEdit/InvoiceEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_invoiceDetail", linkName: "income_invoice" },
            ],
          },
        },
        {
          path: "invoiceCreate",
          name: "income_invoiceCreate",
          component: () => import("./views/peakweb/income/invoice/InvoiceCreate.vue"),
          meta: {
            title: "Menu_invoiceCreate",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_invoiceDetail", linkName: "income_invoice" },
            ],
          },
        },
        {
          path: "recurringInvoiceCreate",
          name: "income_recurringInvoiceCreate",
          component: () => import("./views/peakweb/income/invoice/RecurringInvoiceCreate.vue"),
          meta: {
            title: "Create_Recurring_Invoice",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_invoiceDetail", linkName: "income_invoice" },
              { name: "Create_Recurring_Invoice" },
            ],
          },
        },
        {
          path: "recurringInvoiceEdit",
          name: "income_recurringInvoiceEdit",
          component: () => import("./views/peakweb/income/invoice/invoiceEdit/RecurringInvoiceEdit.vue"),
          meta: {
            title: "Edit_Recurring_Invoice",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_invoiceDetail", linkName: "income_invoice" },
              { name: "Edit_Recurring_Invoice" },
            ],
          },
        },
        {
          path: "recurringInvoiceDetail",
          name: "income_recurringInvoiceDetail",
          component: () => import("./views/peakweb/income/invoice/invoiceDetail/RecurringInvoiceDetail.vue"),
          meta: {
            title: "Recurring_Invoice",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_invoiceDetail", linkName: "income_invoice" },
              { name: "Recurring_Invoice" },
            ],
          },
        },
        {
          path: "receipt",
          name: "income_receipt",
          component: () => import("./views/peakweb/income/receipt/Receipt.vue"),
          meta: {
            title: "Menu_Receipt",
            breadcrumb: [{ name: "Menu_income", linkName: "income" }, { name: "Menu_Receipt" }],
          },
        },
        {
          path: "receiptDetail",
          name: "income_receiptDetail",
          component: () => import("./views/peakweb/income/receipt/receiptDetail/ReceiptDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_Receipt", linkName: "income_receipt" },
            ],
          },
        },
        {
          path: "receiptEdit",
          name: "income_receiptEdit",
          component: () => import("./views/peakweb/income/receipt/receiptEdit/ReceiptEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_Receipt", linkName: "income_receipt" },
            ],
          },
        },
        {
          path: "receiptCreate",
          name: "income_receiptCreate",
          component: () => import("./views/peakweb/income/receipt/ReceiptCreate.vue"),
          meta: {
            title: "Menu_ReceiptCreate",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_Receipt", linkName: "income_receipt" },
            ],
          },
        },
        {
          path: "recurringReceiptCreate",
          name: "income_recurringReceiptCreate",
          component: () => import("./views/peakweb/income/receipt/RecurringReceiptCreate.vue"),
          meta: {
            title: "Create_Recurring_Receipt",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_Receipt", linkName: "income_receipt" },
              { name: "Create_Recurring_Receipt" },
            ],
          },
        },
        {
          path: "recurringReceiptDetail",
          name: "income_recurringReceiptDetail",
          component: () => import("./views/peakweb/income/receipt/receiptDetail/RecurringReceiptDetail.vue"),
          meta: {
            title: "Recurring_Receipt",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_Receipt", linkName: "income_receipt" },
              { name: "Recurring_Receipt" },
            ],
          },
        },
        {
          path: "recurringReceiptEdit",
          name: "income_recurringReceiptEdit",
          component: () => import("./views/peakweb/income/receipt/receiptEdit/RecurringReceiptEdit.vue"),
          meta: {
            title: "Edit_Recurring_Receipt",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_Receipt", linkName: "income_receipt" },
              { name: "Edit_Recurring_Receipt" },
            ],
          },
        },
        {
          path: "taxinvoice",
          name: "income_taxinvoice",
          component: () => import("./views/peakweb/income/taxinvoice/Taxinvoice.vue"),
          meta: {
            title: "Menu_SalesTaxInvoice",
            breadcrumb: [{ name: "Menu_income", linkName: "income" }, { name: "Menu_SalesTaxInvoice" }],
          },
        },
        {
          path: "taxinvoiceCreate",
          name: "income_taxinvoiceCreate",
          component: () =>
            import("./views/peakweb/income/taxinvoice/taxInvoiceCreate/TaxInvoiceCreateSelectInvioce.vue"),
          meta: {
            title: "Menu_SalesTaxInvoiceCreate",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_SalesTaxInvoice", linkName: "income_taxinvoice" },
              { name: "Create_Sales_Tax_Invoice" },
            ],
          },
        },
        {
          path: "taxinvoiceDetail",
          name: "income_taxinvoiceDetail",
          component: () => import("./views/peakweb/income/taxinvoice/taxInvoiceDetail/TaxInvoiceDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_SalesTaxInvoice", linkName: "income_taxinvoice" },
            ],
          },
        },
        {
          path: "taxinvoiceEdit",
          name: "income_taxinvoiceEdit",
          component: () => import("./views/peakweb/income/taxinvoice/taxInvoiceEdit/TaxInvoiceEdit.vue"),
          meta: {
            title: "Menu_SalesTaxInvoice",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_SalesTaxInvoice", linkName: "income_taxinvoice" },
            ],
          },
        },
        {
          path: "creditNote",
          name: "income_creditNote",
          component: () => import("./views/peakweb/income/creditNote/CreditNote.vue"),
          meta: {
            title: "Menu_CreditNote",
            breadcrumb: [{ name: "Menu_income", linkName: "income" }, { name: "Menu_CreditNote" }],
          },
        },
        {
          path: "creditNoteCreate",
          name: "income_creditNoteCreate",
          component: () => import("./views/peakweb/income/creditNote/creditNoteCreate/CreditNoteCreate.vue"),
          meta: {
            title: "Menu_CreditNoteCreate",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_CreditNote", linkName: "income_creditNote" },
              { name: "Menu_CreditNoteCreate" },
            ],
          },
        },
        {
          path: "creditNoteEdit",
          name: "income_creditNoteEdit",
          component: () => import("./views/peakweb/income/creditNote/creditNoteEdit/CreditNoteEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_CreditNote", linkName: "income_creditNote" },
            ],
          },
        },
        {
          path: "creditNoteDetail",
          name: "income_creditNoteDetail",
          component: () => import("./views/peakweb/income/creditNote/creditNoteDetail/CreditNoteDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_CreditNote", linkName: "income_creditNote" },
            ],
          },
        },
        {
          path: "debitNote",
          name: "income_debitNote",
          component: () => import("./views/peakweb/income/debitNote/DebitNote.vue"),
          meta: {
            title: "Menu_DebitNote",
            breadcrumb: [{ name: "Menu_income", linkName: "income" }, { name: "Menu_DebitNote" }],
          },
        },
        {
          path: "debitNoteCreate",
          name: "income_debitNoteCreate",
          component: () => import("./views/peakweb/income/debitNote/debitNoteCreate/DebitNoteCreate.vue"),
          meta: {
            title: "Menu_DebitNoteCreate",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_DebitNote", linkName: "income_debitNote" },
              { name: "Menu_DebitNoteCreate" },
            ],
          },
        },
        {
          path: "debitNoteEdit",
          name: "income_debitNoteEdit",
          component: () => import("./views/peakweb/income/debitNote/debitNoteEdit/DebitNoteEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_DebitNote", linkName: "income_debitNote" },
            ],
          },
        },
        {
          path: "debitNoteDetail",
          name: "income_debitNoteDetail",
          component: () => import("./views/peakweb/income/debitNote/debitNoteDetail/DebitNoteDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_DebitNote", linkName: "income_debitNote" },
            ],
          },
        },
        {
          path: "billingNote",
          name: "income_billingNote",
          component: () => import("./views/peakweb/income/billingNote/BillingNote.vue"),
          meta: {
            title: "Menu_BillingNote",
            breadcrumb: [{ name: "Menu_income", linkName: "income" }, { name: "Menu_BillingNote" }],
          },
        },
        {
          path: "billingNoteCreate",
          name: "income_billingNoteCreate",
          component: () => import("./views/peakweb/income/billingNote/billingNoteCreate/BillingNoteCreate.vue"),
          meta: {
            title: "Menu_BillingNote",
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_BillingNote", linkName: "income_billingNote" },
              { name: "Menu_BillingNoteCreate" },
            ],
          },
        },
        {
          path: "billingNoteEdit",
          name: "income_billingNoteEdit",
          component: () => import("./views/peakweb/income/billingNote/billingNoteEdit/BillingNoteEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_BillingNote", linkName: "income_billingNote" },
            ],
          },
        },
        {
          path: "billingNoteDetail",
          name: "income_billingNoteDetail",
          component: () => import("./views/peakweb/income/billingNote/billingNoteDetail/BillingNoteDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_income", linkName: "income" },
              { name: "Menu_BillingNote", linkName: "income_billingNote" },
            ],
          },
        },
      ],
    },
    // expense Page
    {
      path: "/expense",
      name: "expense",
      component: () => import("./views/peakweb/expense/Expense.vue"),
      meta: { title: "Menu_expense", breadcrumb: [{ name: "Menu_expense" }] },
      children: [
        //PurchaseRequisition
        {
          path: "PurchaseRequisition",
          name: "expense_purchaseRequisition",
          component: () => import("./views/peakweb/expense/purchaseRequisition/PurchaseRequisition.vue"),
          meta: {
            title: "Menu_PurchaseRequisition",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_PurchaseRequisition", linkName: "expense_purchaseRequisition" },
            ],
          },
        },
        {
          path: "PurchaseRequisitionDetail",
          name: "expense_purchaseRequisitionDetail",
          component: () =>
            import(
              "./views/peakweb/expense/purchaseRequisition/purchaseRequisitionDetail/PurchaseRequisitionDetail.vue"
            ),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_PurchaseRequisition", linkName: "expense_purchaseRequisition" },
            ],
          },
        },
        {
          path: "PurchaseRequisitionEdit",
          name: "expense_purchaseRequisitionEdit",
          component: () =>
            import("./views/peakweb/expense/purchaseRequisition/purchaseRequisitionEdit/PurchaseRequisitionEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_PurchaseRequisition", linkName: "expense_purchaseRequisition" },
            ],
          },
        },
        {
          path: "PurchaseRequisitionCreate",
          name: "expense_purchaseRequisitionCreate",
          component: () => import("./views/peakweb/expense/purchaseRequisition/PurchaseRequisitionCreate.vue"),
          meta: {
            title: "Menu_PurchaseRequisitionCreate",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_PurchaseRequisition", linkName: "expense_purchaseRequisition" },
              { name: "Menu_PurchaseRequisitionCreate" },
            ],
          },
        },
        {
          path: "PO",
          name: "expense_PO",
          component: () => import("./views/peakweb/expense/po/PO.vue"),
          meta: {
            title: "Menu_PurchaseOrder",
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }],
          },
        },
        {
          path: "PODetail",
          name: "expense_PODetail",
          component: () => import("./views/peakweb/expense/po/poDetail/PoDetail.vue"),
          meta: {
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }],
          },
        },
        {
          path: "POEdit",
          name: "expense_POEdit",
          component: () => import("./views/peakweb/expense/po/poEdit/POEdit.vue"),
          meta: {
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }],
          },
        },
        {
          path: "POCreate",
          name: "expense_POCreate",
          component: () => import("./views/peakweb/expense/po/POCreate.vue"),
          meta: {
            title: "Menu_PurchaseOrderCreate",
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }],
          },
        },
        {
          path: "deposit",
          name: "expense_deposit",
          component: () => import("./views/peakweb/expense/deposit/Deposit.vue"),
          meta: {
            title: "Menu_depositPayment",
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }, { name: "Menu_depositPayment" }],
          },
        },
        {
          path: "depositCreate",
          name: "expense_depositCreate",
          component: () => import("./views/peakweb/expense/deposit/DepositCreate.vue"),
          meta: {
            title: "Menu_depositPaymentCreate",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_depositPayment", linkName: "expense_deposit" },
              { name: "Menu_depositPaymentCreate" },
            ],
          },
        },
        {
          path: "depositDetail",
          name: "expense_depositDetail",
          component: () => import("./views/peakweb/expense/deposit/depositDetail/DepositDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_depositPayment", linkName: "expense_deposit" },
            ],
          },
        },
        {
          path: "depositEdit",
          name: "expense_depositEdit",
          component: () => import("./views/peakweb/expense/deposit/depositEdit/DepositEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_depositPayment", linkName: "expense_deposit" },
            ],
          },
        },
        {
          path: "goodsReceipt",
          name: "expense_goodsReceipt",
          component: () => import("./views/peakweb/expense/goodsReceipt/GoodsReceipt.vue"),
          meta: {
            title: "Menu_goodsReceipt",
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }, { name: "Menu_goodsReceipt" }],
          },
        },
        {
          path: "goodsReceiptCreate",
          name: "expense_goodsReceiptCreate",
          component: () => import("./views/peakweb/expense/goodsReceipt/GoodsReceiptCreate.vue"),
          meta: {
            title: "Menu_goodsReceiptCreate",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_goodsReceipt", linkName: "expense_goodsReceipt" },
              { name: "Menu_goodsReceiptCreate" },
            ],
          },
        },
        {
          path: "goodsReceiptDetail",
          name: "expense_goodsReceiptDetail",
          component: () => import("./views/peakweb/expense/goodsReceipt/goodsReceiptDetail/GoodsReceiptDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_goodsReceipt", linkName: "expense_goodsReceipt" },
            ],
          },
        },
        {
          path: "goodsReceiptEdit",
          name: "expense_goodsReceiptEdit",
          component: () => import("./views/peakweb/expense/goodsReceipt/goodsReceiptEdit/GoodsReceiptEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_goodsReceipt", linkName: "expense_goodsReceipt" },
            ],
          },
        },
        {
          path: "invoiceReceipt",
          name: "expense_invoiceReceipt",
          component: () => import("./views/peakweb/expense/invoiceReceipt/InvoiceReceipt.vue"),
          meta: {
            title: "Menu_invoiceReceipt",
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }, { name: "Menu_invoiceReceipt" }],
          },
        },
        {
          path: "invoiceReceiptCreate",
          name: "expense_invoiceReceiptCreate",
          component: () => import("./views/peakweb/expense/invoiceReceipt/InvoiceReceiptCreate.vue"),
          meta: {
            title: "Menu_invoiceReceiptCreate",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_invoiceReceipt", linkName: "expense_invoiceReceipt" },
              { name: "Menu_invoiceReceiptCreate" },
            ],
          },
        },
        {
          path: "invoiceReceiptDetail",
          name: "expense_invoiceReceiptDetail",
          component: () =>
            import("./views/peakweb/expense/invoiceReceipt/invoiceReceiptDetail/InvoiceReceiptDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_invoiceReceipt", linkName: "expense_invoiceReceipt" },
            ],
          },
        },
        {
          path: "invoiceReceiptEdit",
          name: "expense_invoiceReceiptEdit",
          component: () => import("./views/peakweb/expense/invoiceReceipt/invoiceReceiptEdit/InvoiceReceiptEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_invoiceReceipt", linkName: "expense_invoiceReceipt" },
            ],
          },
        },
        {
          path: "invoice",
          name: "expense_invoice",
          component: () => import("./views/peakweb/expense/invoice/Invoice.vue"),
          meta: {
            title: "Menu_PurchaseInventoryRecord/RecordExpense",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_PurchaseInventoryRecord/RecordExpense" },
            ],
          },
        },
        {
          path: "invoiceDetail",
          name: "expense_invoiceDetail",
          component: () => import("./views/peakweb/expense/invoice/invoiceDetail/InvoiceDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_RecordExpenseAP", linkName: "expense_invoice" },
            ],
          },
        },
        {
          path: "invoiceEdit",
          name: "expense_invoiceEdit",
          component: () => import("./views/peakweb/expense/invoice/invoiceEdit/InvoiceEdit.vue"),
          meta: {
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }],
          },
        },
        {
          path: "invoiceCreate",
          name: "expense_invoiceCreate",
          component: () => import("./views/peakweb/expense/invoice/InvoiceCreate.vue"),
          meta: {
            title: "Record_New_Expense",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_PurchaseInventoryRecord/RecordExpense",
                linkName: "expense_invoice",
              },
              { name: "Record_New_Expense" },
            ],
          },
        },
        {
          path: "purchaseInventory",
          name: "expense_purchaseInventoryCreate",
          component: () => import("./views/peakweb/expense/invoice/purchaseInventoryCreate.vue"),
          meta: {
            title: "Purchase_Inventory_header",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_PurchaseInventoryRecord/RecordExpense",
                linkName: "expense_invoice",
              },
              { name: "Purchase_Inventory_header" },
            ],
          },
        },
        {
          path: "recurringInvoiceCreate",
          name: "expense_recurringInvoiceCreate",
          component: () => import("./views/peakweb/expense/invoice/RecurringInvoiceCreate.vue"),
          meta: {
            title: "Create_Recurring_Expense",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_PurchaseInventoryRecord/RecordExpense",
                linkName: "expense_invoice",
              },
              { name: "Create_Recurring_Expense" },
            ],
          },
        },
        {
          path: "recurringInvoiceEdit",
          name: "expense_recurringInvoiceEdit",
          component: () => import("./views/peakweb/expense/invoice/invoiceEdit/RecurringInvoiceEdit.vue"),
          meta: {
            title: "Edit_Recurring_Expense",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_PurchaseInventoryRecord/RecordExpense",
                linkName: "expense_invoice",
              },
              { name: "Edit_Recurring_Expense" },
            ],
          },
        },
        {
          path: "recurringInvoiceDetail",
          name: "expense_recurringInvoiceDetail",
          component: () => import("./views/peakweb/expense/invoice/invoiceDetail/RecurringInvoiceDetail.vue"),
          meta: {
            title: "Recurring_Expense",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_PurchaseInventoryRecord/RecordExpense",
                linkName: "expense_invoice",
              },
              { name: "Recurring_Expense" },
            ],
          },
        },
        {
          path: "fixedAsset",
          name: "expense_fixedAsset",
          component: () => import("./views/peakweb/expense/fixedAsset/FixedAsset.vue"),
          meta: {
            title: "Menu_PurchaseAsset",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_PurchaseAsset", linkName: "expense_fixedAsset" },
            ],
          },
        },
        {
          path: "fixedAssetDetail",
          name: "expense_fixedAssetDetail",
          component: () => import("./views/peakweb/expense/fixedAsset/fixedAssetDetail/FixedAssetDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_PurchaseAsset", linkName: "expense_fixedAsset" },
            ],
          },
        },
        {
          path: "fixedAssetCreate",
          name: "expense_fixedAssetCreate",
          component: () => import("./views/peakweb/expense/fixedAsset/FixedAssetCreate.vue"),

          meta: {
            title: "Purchase_Asset_Record",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_PurchaseAsset", linkName: "expense_fixedAsset" },
              { name: "Purchase_Asset_Record" },
            ],
          },
        },
        {
          path: "fixedAssetEdit",
          name: "expense_fixedAssetEdit",
          component: () => import("./views/peakweb/expense/fixedAsset/FixedAssetEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_PurchaseAsset", linkName: "expense_fixedAsset" },
            ],
          },
        },
        {
          path: "taxinvoice",
          name: "expense_taxinvoice",
          component: () => import("./views/peakweb/expense/taxinvoice/Taxinvoice.vue"),
          meta: {
            title: "Menu_PurchaseTaxInvice",
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }, { name: "Menu_PurchaseTaxInvice" }],
          },
        },
        {
          path: "taxInvoiceDetail",
          name: "expense_taxInvoiceDetail",
          component: () => import("./views/peakweb/expense/taxinvoice/TaxInvoiceDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_PurchaseTaxInvice",
                linkName: "expense_taxinvoice",
              },
            ],
          },
        },
        {
          path: "creditNote",
          name: "expense_creditNote",
          component: () => import("./views/peakweb/expense/creditNote/CreditNote.vue"),
          meta: {
            title: "Menu_ReceiveCreditNote",
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }, { name: "Menu_ReceiveCreditNote" }],
          },
        },
        {
          path: "creditNoteCreate",
          name: "expense_creditNoteCreate",
          component: () => import("./views/peakweb/expense/creditNote/creditNoteCreate/CreditNoteCreate.vue"),
          meta: {
            title: "Menu_ReceiveCreditNote",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_ReceiveCreditNote",
                linkName: "expense_creditNote",
              },
              { name: "Create_Receive_Credit_Note" },
            ],
          },
        },
        {
          path: "creditNoteEdit",
          name: "expense_creditNoteEdit",
          component: () => import("./views/peakweb/expense/creditNote/creditNoteEdit/CreditNoteEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_ReceiveCreditNote",
                linkName: "expense_creditNote",
              },
            ],
          },
        },
        {
          path: "creditNoteDetail",
          name: "expense_creditNoteDetail",
          component: () => import("./views/peakweb/expense/creditNote/creditNoteDetail/CreditNoteDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_ReceiveCreditNote",
                linkName: "expense_creditNote",
              },
            ],
          },
        },
        {
          path: "debitNote",
          name: "expense_debitNote",
          component: () => import("./views/peakweb/expense/debitNote/DebitNote.vue"),
          meta: {
            title: "Menu_ReceiveDebitNote",
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }, { name: "Menu_ReceiveDebitNote" }],
          },
        },
        {
          path: "debitNoteCreate",
          name: "expense_debitNoteCreate",
          component: () => import("./views/peakweb/expense/debitNote/debitNoteCreate/DebitNoteCreate.vue"),
          meta: {
            title: "Menu_ReceiveDebitNote",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_ReceiveDebitNote", linkName: "expense_debitNote" },
              { name: "Create_Receive_Debit_Note" },
            ],
          },
        },
        {
          path: "debitNoteEdit",
          name: "expense_debitNoteEdit",
          component: () => import("./views/peakweb/expense/debitNote/debitNoteEdit/DebitNoteEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_ReceiveDebitNote", linkName: "expense_debitNote" },
            ],
          },
        },
        {
          path: "debitNoteDetail",
          name: "expense_debitNoteDetail",
          component: () => import("./views/peakweb/expense/debitNote/debitNoteDetail/DebitNoteDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              { name: "Menu_ReceiveDebitNote", linkName: "expense_debitNote" },
            ],
          },
        },
        {
          path: "billingNote",
          name: "expense_billingNote",
          component: () => import("./views/peakweb/expense/billingNote/BillingNote.vue"),
          meta: {
            title: "Menu_CombinedPaymentNote",
            breadcrumb: [{ name: "Menu_expense", linkName: "expense" }, { name: "Menu_CombinedPaymentNote" }],
          },
        },
        {
          path: "billingNoteCreate",
          name: "expense_billingNoteCreate",
          component: () => import("./views/peakweb/expense/billingNote/billingNoteCreate/BillingNoteCreate.vue"),
          meta: {
            title: "Menu_CombinedPaymentNoteCreate",
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_CombinedPaymentNote",
                linkName: "expense_billingNote",
              },
              { name: "Menu_CombinedPaymentNoteCreate" },
            ],
          },
        },
        {
          path: "billingNoteEdit",
          name: "expense_billingNoteEdit",
          component: () => import("./views/peakweb/expense/billingNote/billingNoteEdit/BillingNoteEdit.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_CombinedPaymentNote",
                linkName: "expense_billingNote",
              },
            ],
          },
        },
        {
          path: "billingNoteDetail",
          name: "expense_billingNoteDetail",
          component: () => import("./views/peakweb/expense/billingNote/billingNoteDetail/BillingNoteDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_expense", linkName: "expense" },
              {
                name: "Menu_CombinedPaymentNote",
                linkName: "expense_billingNote",
              },
            ],
          },
        },
      ],
    },
    // Contact Page
    {
      path: "/contact",
      name: "contact",
      component: () => import("./views/peakweb/contact/Contact.vue"),
      meta: { title: "Menu_contact", breadcrumb: [{ name: "Menu_contact" }] },
      children: [
        {
          path: "detail",
          name: "contactDetail",
          component: () => import("./views/peakweb/contact/contactDetail/ContactDetail.vue"),
          meta: { breadcrumb: [{ name: "Menu_contact", linkName: "contact" }] },
        },
        {
          path: "importContactPreview",
          name: "importContactPreview",
          component: () => import("./views/peakweb/contact/importContact/ImportContactPreview.vue"),
          meta: {
            title: "Import_Contact",
            breadcrumb: [{ name: "Menu_contact", linkName: "contact" }, { name: "Create_Import_Document" }],
          },
        },
      ],
    },
    // product Page
    {
      path: "/product",
      name: "product",
      meta: { title: "Menu_product" },
      component: () => import("./views/peakweb/product/Product.vue"),
      redirect: "/product/productIndex",
      children: [
        {
          path: "productIndex",
          name: "productIndex",
          component: () => import("./views/peakweb/product/productIndex/ProductIndex"),
          props(route) {
            return route.query || {};
          },
          meta: { title: "Product", breadcrumb: [{ name: "Product" }] },
        },
        {
          path: "productTemplateDetail",
          name: "productTemplateDetail",
          component: () => import("./views/peakweb/product/productDetail/ProductDetail"),
          meta: {
            breadcrumb: [{ name: "Menu_ProductService", linkName: "productIndex" }],
          },
        },
        {
          path: "unit",
          name: "unitIndex",
          component: () => import("./views/peakweb/product/unitIndex/UnitIndex.vue"),
          props(route) {
            return route.query || {};
          },
          meta: { title: "Menu_product", breadcrumb: [{ name: "Menu_Unit" }] },
        },
        {
          path: "importProductPreview",
          name: "importProductPreview",
          component: () => import("./views/peakweb/product/importProduct/ImportProductPreview.vue"),
          props(route) {
            return route.query || {};
          },
          meta: {
            title: "Create_Import_Document",
            breadcrumb: [{ name: "Product", linkName: "productIndex" }, { name: "Create_Import_Document" }],
          },
        },
        {
          path: "service",
          name: "service",
          component: () => import("./views/peakweb/product/service/Service.vue"),
          props(route) {
            return route.query || {};
          },
          meta: { title: "Service", breadcrumb: [{ name: "Service" }] },
        },
        {
          path: "importServicePreview",
          name: "importServicePreview",
          component: () => import("./views/peakweb/product/importProduct/ImportProductPreview.vue"),
          props(route) {
            return route.query || {};
          },
          meta: {
            title: "Create_Import_Document",
            breadcrumb: [{ name: "Service", linkName: "service" }, { name: "Create_Import_Document" }],
          },
        },
        {
          path: "OnPageGuideProduct",
          name: "OnPageGuideProduct",
          component: () => import("./views/peakweb/product/modal/ModalOnPageGuideProduct.vue"),
          props(route) {
            return route.query || {};
          },
          meta: {
            title: "OnPageGuideProduct",
          },
        },
      ],
    },
    // Finance Page
    {
      path: "/finance",
      name: "finance",
      meta: {
        title: "Menu_finance",
        breadcrumb: [{ name: "Header_OverviewStatement" }],
      },
      component: () => import("./views/peakweb/finance/Finance.vue"),
      children: [
        {
          path: "cashBankWallet",
          name: "cashBankWallet",
          component: () => import("./views/peakweb/finance/cashBank/CashBankWallet.vue"),
          meta: {
            title: "Menu_finance",
            breadcrumb: [{ name: "Header_OverviewStatement", linkName: "finance" }, { name: "Header_CashBank" }],
          },
        },
        {
          path: "expenseClaim",
          name: "expenseClaim",
          component: () => import("./views/peakweb/finance/expenseClaim/expenseClaim.vue"),
          meta: {
            title: "Menu_finance",
            breadcrumb: [{ name: "Header_OverviewStatement", linkName: "finance" }, { name: "Menu_ExpenseClaims" }],
          },
        },
        {
          path: "detail",
          name: "detail",
          component: () => import("./views/peakweb/finance/cashBank/Detail.vue"),
          meta: {
            title: "Menu_finance",
            breadcrumb: [{ name: "Header_OverviewStatement", linkName: "finance" }],
          },
        },
        {
          path: "reconcile",
          name: "reconcile",
          component: () => import("./views/peakweb/finance/cashBank/reconcile/Reconcile.vue"),
          meta: {
            title: "Menu_finance",
            breadcrumb: [{ name: "Header_OverviewStatement", linkName: "finance" }],
          },
        },
        {
          path: "chequeExpense",
          name: "chequeExpense",
          meta: {
            title: "Menu_finance",
            breadcrumb: [{ name: "Header_OverviewStatement", linkName: "finance" }, { name: "Header_AllChequeIssue" }],
          },
          component: () => import("./views/peakweb/finance/cheque/ChequeExpense.vue"),
        },
        {
          path: "chequeReceive",
          name: "chequeReceive",
          meta: {
            title: "Menu_finance",
            breadcrumb: [
              { name: "Header_OverviewStatement", linkName: "finance" },
              { name: "Header_AllChequeReceive" },
            ],
          },
          component: () => import("./views/peakweb/finance/cheque/ChequeReceive.vue"),
        },
        {
          path: "tax",
          name: "tax",
          meta: {
            title: "Menu_finance",
            breadcrumb: [{ name: "Header_OverviewStatement", linkName: "finance" }, { name: "Menu_WithholdingTax" }],
          },
          component: () => import("./views/peakweb/finance/tax/Tax.vue"),
        },
        {
          path: "taxed",
          name: "taxed",
          meta: {
            title: "Menu_finance",
            breadcrumb: [{ name: "Header_OverviewStatement", linkName: "finance" }, { name: "Menu_WithheldTax" }],
          },
          component: () => import("./views/peakweb/finance/tax/Taxed.vue"),
        },
        {
          path: "paymentTransfer",
          name: "paymentTransfer",
          meta: {
            title: "Menu_finance",
            breadcrumb: [{ name: "Header_OverviewStatement", linkName: "finance" }, { name: "Menu_PaymentTransfer" }],
          },
          component: () => import("./views/peakweb/finance/paymentTransfer/PaymentTransfer.vue"),
        },
        {
          path: "paymentTransferCreate",
          name: "finance_paymentTransferCreate",
          component: () =>
            import("@/views/peakweb/finance/paymentTransfer/paymentTransferCreate/PaymentTransferCreate.vue"),
          meta: {
            title: "Menu_PaymentTransferCreate",
            breadcrumb: [
              { name: "Header_OverviewStatement", linkName: "finance" },
              {
                name: "Menu_PaymentTransfer",
                linkName: "paymentTransfer",
              },
              { name: "Menu_PaymentTransferCreate" },
            ],
          },
        },
        {
          path: "paymentTransferDetail",
          name: "finance_paymentTransferDetail",
          component: () => import("@/views/peakweb/finance/paymentTransfer/PaymentTransferDetail.vue"),
          meta: {
            title: "Menu_PaymentTransferCreate",
            breadcrumb: [
              { name: "Header_OverviewStatement", linkName: "finance" },
              {
                name: "Menu_PaymentTransfer",
                linkName: "paymentTransfer",
              },
              { name: "Menu_PaymentTransferCreate" },
            ],
          },
        },
      ],
    },

    // Account Page
    {
      path: "/account",
      name: "account",
      component: () => import("./views/peakweb/account/Account.vue"),
      meta: { title: "Menu_account", breadcrumb: [{ name: "Menu_account" }] },
      children: [
        {
          // ผังบํญชี
          path: "chartOfAccount",
          name: "chartOfAccount",
          component: () => import("./views/peakweb/account/chartOfAccount/ChartOfAccount.vue"),
          props(route) {
            return route.query || {};
          },
          meta: {
            title: "Menu_ChartOfAccount",
            breadcrumb: [{ name: "Menu_account" }, { name: "Menu_ChartOfAccount" }],
          },
        },
        {
          // สมุดบัญชี
          path: "dailyJournal",
          name: "dailyJournal",
          component: () => import("./views/peakweb/account/dailyJournal/DailyJournal.vue"),
          props(route) {
            return route.query || {};
          },
          meta: {
            title: "Menu_DailyJournal",
            breadcrumb: [{ name: "Menu_account" }, { name: "Menu_DailyJournal" }],
          },
        },
        // บันทึกบัญชี
        {
          path: "dailyJournalCreate",
          name: "dailyJournalCreate",
          component: () => import("./views/peakweb/account/dailyJournal/dailyJournalCreate/AccountRecord.vue"),
          meta: {
            title: "Journal_No",
            breadcrumb: [
              { name: "Menu_account" },
              { name: "Menu_DailyJournal", linkName: "dailyJournal" },
              { name: "Account_Record" },
            ],
          },
        },
        {
          path: "dailyJournalEdit",
          name: "dailyJournalEdit",
          component: () => import("./views/peakweb/account/dailyJournal/dailyJournalCreate/DailyJournalEdit.vue"),
          meta: {
            title: "Edit_Account_Record",
            breadcrumb: [{ name: "Menu_account" }, { name: "Menu_DailyJournal", linkName: "dailyJournal" }],
          },
        },
        // รายละเอียดบันทึกบัญชี
        {
          path: "dailyJournalDetail",
          name: "dailyJournalDetail",
          component: () => import("./views/peakweb/account/dailyJournal/dailyJournalDetail/DailyJournalDetail.vue"),
          meta: {
            breadcrumb: [{ name: "Menu_account" }, { name: "Menu_DailyJournal", linkName: "dailyJournal" }],
          },
        },
        {
          // บัญชีแยกประเภท
          path: "generalLedger",
          name: "generalLedger",
          component: () => import("./views/peakweb/account/generalLedger/GeneralLedger.vue"),
          meta: {
            title: "Menu_GeneralLedger",
            breadcrumb: [{ name: "Menu_account" }, { name: "Menu_GeneralLedger" }],
          },
        },
        {
          // งบทดลอง
          path: "trialBalance",
          name: "trialBalance",
          component: () => import("./views/peakweb/account/trialBalance/TrialBalance.vue"),
          meta: {
            title: "Menu_TrialBalance",
            breadcrumb: [{ name: "Menu_account", link: "account" }, { name: "Menu_TrialBalance" }],
          },
        },
        {
          // งบฐานะการเงิน
          path: "balanceSheet",
          name: "balanceSheet",
          component: () => import("./views/peakweb/account/balanceSheet/BalanceSheet.vue"),
          meta: {
            title: "Menu_BalanceSheet",
            breadcrumb: [{ name: "Menu_account", link: "account" }, { name: "Menu_BalanceSheet" }],
          },
        },
        {
          // แก้ไขงบกำไรขาดทุน
          path: "balanceSheetTemplateEdit",
          name: "balanceSheetTemplateEdit",
          component: () => import("./views/peakweb/account/balanceSheet/balanceSheetEdit/BalanceSheetEdit.vue"),
          meta: {
            title: "Menu_BalanceSheetEdit",
            breadcrumb: [
              { name: "Menu_account" },
              { name: "Menu_BalanceSheet", linkName: "balanceSheet" },
              { name: "Menu_BalanceSheetEdit" },
            ],
          },
        },
        {
          // งบกำไรขาดทุน
          path: "profitLoss",
          name: "profitLoss",
          component: () => import("./views/peakweb/account/profitLoss/ProfitLoss.vue"),
          meta: {
            title: "Menu_IncomeStatement",
            breadcrumb: [{ name: "Menu_account", link: "account" }, { name: "Menu_IncomeStatement" }],
          },
        },
        {
          // แก้ไขงบกำไรขาดทุน
          path: "profitLossTemplateEdit",
          name: "profitLossTemplateEdit",
          component: () => import("./views/peakweb/account/profitLoss/profitLossEdit/ProfitLossEdit.vue"),
          meta: {
            title: "Menu_IncomeStatementEdit",
            breadcrumb: [
              { name: "Menu_account" },
              { name: "Menu_IncomeStatement", linkName: "profitLoss" },
              { name: "Menu_IncomeStatementEdit" },
            ],
          },
        },
        {
          // งบกระแสเงินสด
          path: "cashflowStatement",
          name: "cashflowStatement",
          component: () => import("./views/peakweb/account/cashflowStatement/CashflowStatement.vue"),
          meta: {
            title: "Menu_CashflowStatement",
            breadcrumb: [{ name: "Menu_account", link: "account" }, { name: "Menu_CashflowStatement" }],
          },
        },
        {
          // DBD e-Filing
          path: "dbdEFiling",
          name: "dbdEFiling",
          component: () => import("./views/peakweb/account/dbdEFiling/DbdEFiling.vue"),
          meta: {
            title: "Menu_DBD_EFiling",
            breadcrumb: [{ name: "Menu_account", link: "account" }, { name: "Menu_DBD_EFiling" }],
          },
        },
        {
          // DBD e-Filing
          path: "dbdEFilingDetail",
          name: "dbdEFilingDetail",
          component: () => import("./views/peakweb/account/dbdEFiling/dbdEFilingDetail/DBDEFilingDetail.vue"),
          meta: {
            breadcrumb: [
              { name: "Menu_account", link: "account" },
              { name: "Menu_DBD_EFiling", linkName: "dbdEFiling" },
            ],
          },
        },
        {
          //เตรียมข้อมูล DBD e-Filing
          path: "dbdEFilingCreate",
          name: "dbdEFilingCreate",
          component: () => import("./views/peakweb/account/dbdEFiling/dbdEFilingCreate/DbdEFilingCreate.vue"),
          meta: {
            title: "Create_New_DBD_EFiling",
            breadcrumb: [
              { name: "Menu_account", link: "account" },
              { name: "Menu_DBD_EFiling", linkName: "dbdEFiling" },
              { name: "Create_New_DBD_EFiling" },
            ],
          },
        },
        {
          // รายงานเอกสาร
          path: "transactionReport",
          name: "transactionReport",
          component: () => import("./views/peakweb/account/report/TransactionReport.vue"),
        },
        {
          // รวมรายงาน
          path: "allReport",
          name: "allReport",
          component: () => import("./views/peakweb/account/allReport/AllReport.vue"),
        },
        {
          // สิททรัพย์
          path: "fixedAsset",
          name: "fixedAsset",
          component: () => import("./views/peakweb/account/fixedAsset/FixedAsset.vue"),
          meta: {
            title: "FixedAsset",
          },
        },
      ],
    },
    // Document Page
    {
      path: "/document",
      name: "document",
      meta: { title: "Document" },
      component: () => import("./views/peakweb/upload/Upload.vue"),
      redirect: "/document/uploadDocument",
      children: [
        {
          path: "uploadDocument",
          name: "uploadDocument",
          meta: {
            title: "Menu_UploadDocument",
            breadcrumb: [{ name: "Menu_document" }, { name: "Menu_UploadDocument" }],
          },
          component: () => import("./views/peakweb/upload/UploadDocument.vue"),
        },
        {
          path: "fileVaultCreate",
          name: "fileVaultCreate",
          meta: {
            title: "Menu_UploadDocument",
            breadcrumb: [{ name: "Menu_document" }, { name: "Menu_UploadDocument", linkName: "uploadDocument" }],
          },
          component: () => import("./views/peakweb/upload/createTransaction/FileVaultCreate.vue"),
        },
      ],
    },
    // Setting Page
    {
      path: "/setting",
      name: "setting",
      redirect: "/setting/company",
      meta: { title: "Menu_setting" },
      component: () => import("./views/peakweb/setting/Setting.vue"),
      children: [
        {
          path: "company",
          name: "companySetting",
          meta: { title: "Menu_Organization" },
          component: () => import("./views/peakweb/setting/companySetting/CompanySetting.vue"),
        },
        {
          path: "logoStamp",
          name: "logoStampSetting",
          meta: { title: "Menu_LogoStamp" },
          component: () => import("./views/peakweb/setting/companySetting/LogoStempSetting.vue"),
        },
        {
          path: "settingUser",
          name: "settingUser",
          meta: { title: "User_Setting" },
          component: () => import("./views/peakweb/setting/settingUser/SettingUser.vue"),
        },
        {
          path: "userSetting",
          name: "userSetting",
          meta: { title: "Menu_UserSetting" },
          component: () => import("./views/peakweb/setting/settingUser/UserSetting.vue"),
        },
        {
          path: "userRole",
          name: "userRole",
          meta: { title: "Menu_UserRole" },
          component: () => import("./views/peakweb/setting/settingUser/userRole/UserRoleTable.vue"),
        },
        {
          path: "manageUserRole",
          name: "manageUserRole",
          meta: {
            title: "Menu_Role_Management",
            breadcrumb: [{ name: "User_Role_Header", linkName: "userRole" }, { name: "Menu_Role_Management" }],
          },
          component: () => import("./views/peakweb/setting/settingUser/userRole/ManageUserRole.vue"),
        },
        {
          path: "registerAccountingFirm",
          name: "RegisterAccountingFirmSetting",
          meta: { title: "Menu_Register_Accounting_Firm" },
          component: () => import("./views/peakweb/setting/registerAccountingFirm/RegisterAccountingFirm.vue"),
        },
        {
          path: "addUser",
          name: "addUser",
          meta: { title: "Menu_UserSetting" },
          component: () => import("./views/peakweb/setting/settingUser/AddUser.vue"),
        },
        {
          path: "addNewUser",
          name: "addNewUser",
          meta: {
            title: "Menu_UserSetting",
            breadcrumb: [{ name: "Menu_UserSetting", linkName: "userSetting" }, { name: "Menu_UserSetting" }],
          },
          component: () => import("./views/peakweb/setting/settingUser/AddNewUser.vue"),
        },
        {
          path: "userRoleDetail",
          name: "userRoleDetail",
          meta: { title: "Menu_UserSetting" },
          component: () => import("./views/peakweb/setting/settingUser/userRole/UserRoleDetail.vue"),
        },
        {
          path: "editUser",
          name: "editUser",
          meta: { title: "Menu_UserSetting" },
          component: () => import("./views/peakweb/setting/settingUser/UserDetail.vue"),
        },
        {
          path: "billing",
          name: "billingSetting",
          meta: { title: "Menu_Package" },
          component: () => import("./views/peakweb/setting/billing/Billing.vue"),
        },
        {
          path: "paymentPackage",
          name: "paymentPackageSetting",
          meta: { title: "Menu_History" },
          component: () => import("./views/peakweb/setting/billing/PaymentIndex.vue"),
        },
        {
          path: "cardInfo",
          name: "cardInfoSetting",
          meta: { title: "Menu_Credit_Card" },
          component: () => import("./views/peakweb/setting/billing/CardInfo.vue"),
        },
        {
          path: "settingTransactionNumber",
          name: "settingTransactionNumber",
          meta: { title: "Menu_RunningNumberDocument" },
          component: () => import("./views/peakweb/setting/settingTransactionNumber/SettingTransactionNumber.vue"),
        },
        {
          path: "classificationGroup",
          name: "settingAllocation",
          meta: { title: "Menu_Classification" },
          component: () => import("./views/peakweb/setting/settingAllocation/SettingAllocation.vue"),
        },
        {
          path: "settingPublicLink",
          name: "settingPublicLink",
          meta: { title: "Menu_Public_Link" },
          component: () => import("./views/peakweb/setting/settingPublicLink/SettingPublicLink.vue"),
        },
        {
          path: "settingTaxInvoice",
          name: "settingTaxInvoice",
          meta: { title: "Munu_Setting_Taxinvoice" },
          component: () => import("./views/peakweb/setting/settingTaxInvoice/SettingTaxInvoice.vue"),
        },
        {
          path: "settingTransactionRemark",
          name: "settingTransactionRemark",
          meta: { title: "Menu_RemarkDocument" },
          component: () => import("./views/peakweb/setting/settingTransactionRemark/SettingTransactionRemark.vue"),
        },
        {
          path: "settingTransactionDueDate",
          name: "settingTransactionDueDate",
          meta: { title: "Menu_DueDateDocument" },
          component: () => import("./views/peakweb/setting/settingTransactionDueDate/SettingTransactionDueDate.vue"),
        },
        {
          path: "settingTransactionVatType",
          name: "settingTransactionVatType",
          meta: { title: "Menu_SettingDocumentPrice" },
          component: () => import("./views/peakweb/setting/settingTransactionVatType/SettingTransactionVatType.vue"),
        },
        {
          path: "settingMerchantLockPeriod",
          name: "settingMerchantLockPeriod",
          meta: { title: "Menu_LockData" },
          component: () => import("./views/peakweb/setting/settingMerchantLockPeriod/SettingMerchantLockPeriod.vue"),
        },
        {
          path: "settingRequestTaxInvoice",
          name: "settingRequestTaxInvoice",
          meta: { title: "Menu_Request_TaxInvoice" },
          component: () => import("./views/peakweb/setting/settingRequestTaxInvoice/SettingRequestTaxInvoice.vue"),
        },
        {
          path: "settingOnlineViewPaymentChannel",
          name: "settingOnlineViewPaymentChannel",
          meta: { title: "Menu_PaymentChannel" },
          component: () =>
            import("./views/peakweb/setting/settingOnlineViewPaymentChannel/SettingOnlineViewPaymentChannel.vue"),
        },
        {
          path: "connectApiQrPaymentDetail",
          name: "connectApiQrPaymentDetail",
          meta: { title: "Menu_PaymentChannel" },
          component: () =>
            import(
              "./views/peakweb/setting/settingOnlineViewPaymentChannel/connectApiQrPayment/ConnectApiQrPaymentDetail.vue"
            ),
        },
        {
          path: "settingCreateDuplicateName",
          name: "settingCreateDuplicateName",
          meta: { title: "Menu_DuplicateName" },
          component: () =>
            import(
              "./views/peakweb/setting/settingAccountingPolicy/settingCreateDuplicateName/SettingCreateDuplicateName.vue"
            ),
        },
        {
          path: "emailReportSetting",
          name: "emailReportSetting",
          meta: { title: "Menu_ReportEmail" },
          component: () =>
            import("./views/peakweb/setting/settingAccountingPolicy/emailReportSetting/EmailReportSetting.vue"),
        },
        {
          path: "eTaxInvoice",
          name: "eTaxInvoice",
          meta: { title: "Menu_eTaxInvoice" },
          component: () => import("./views/peakweb/setting/eTaxInvoice/ETaxInvoice.vue"),
        },
        {
          path: "eTaxInvoiceDetail",
          name: "eTaxInvoiceDetail",
          meta: { title: "Menu_eTaxInvoice" },
          component: () => import("./views/peakweb/setting/eTaxInvoice/ETaxInvoiceDetail.vue"),
        },
        {
          path: "connectPartnerApp",
          name: "connectPartnerApp",
          meta: { title: "Menu_ConnectPartnerApp" },
          component: () => import("./views/peakweb/setting/connectPartnerApp/ConnectPartnerApp.vue"),
        },
        {
          path: "connectPartnerAppDetail",
          name: "connectPartnerAppDetail",
          meta: { title: "Menu_ConnectPartnerApp" },
          component: () => import("./views/peakweb/setting/connectPartnerApp/ConnectPartnerAppDetail.vue"),
        },
        {
          path: "connectOwnUseDetail",
          name: "connectOwnUseDetail",
          meta: { title: "Menu_ConnectPartnerApp" },
          component: () => import("./views/peakweb/setting/connectPartnerApp/ConnectOwnUseDetail.vue"),
        },
        {
          path: "connectPartnerApiQrPaymentDetail",
          name: "connectPartnerApiQrPaymentDetail",
          meta: { title: "Menu_ConnectPartnerApp" },
          component: () => import("./views/peakweb/setting/connectPartnerApp/ConnectPartnerApiQrPaymentDetail.vue"),
        },
        {
          path: "lineShoppingDetail",
          name: "lineShoppingDetail",
          meta: { title: "Menu_ConnectPartnerApp" },
          component: () => import("./views/peakweb/setting/connectPartnerApp/LineMyShopDetail.vue"),
        },
        {
          path: "shopeeDetail",
          name: "shopeeDetail",
          meta: { title: "Menu_ConnectPartnerApp" },
          component: () => import("./views/peakweb/setting/connectPartnerApp/ShopeeDetail.vue"),
        },
        {
          path: "lazadaDetail",
          name: "lazadaDetail",
          meta: { title: "Menu_ConnectPartnerApp" },
          component: () => import("./views/peakweb/setting/connectPartnerApp/LazadaDetail.vue"),
        },
        {
          path: "tiktokDetail",
          name: "tiktokDetail",
          meta: { title: "Menu_ConnectPartnerApp" },
          component: () => import("./views/peakweb/setting/connectPartnerApp/TiktokDetail.vue"),
        },
        {
          path: "creditLimitSetting",
          name: "creditLimitSetting",
          meta: { title: "Menu_Contact_Setting" },
          component: () => import("./views/peakweb/setting/settingCreditLimit/ModalSettingCreditLimit.vue"),
        },
        {
          path: "creditNoteDebitNoteSetting",
          name: "creditNoteDebitNoteSetting",
          meta: { title: "Menu_Revenue_Expense_Setting" },
          component: () =>
            import("./views/peakweb/setting/settingCreditNoteDebitNoteAccount/SettingCreditNoteDebitNoteAccount.vue"),
        },
        {
          path: "productSetting",
          name: "productSetting",
          meta: { title: "Menu_Product_Service_Setting" },
          component: () => import("./views/peakweb/setting/settingProduct/SettingProduct.vue"),
        },
        {
          path: "partialQuotationSetting",
          name: "partialQuotationSetting",
          meta: { title: "Text_PartialQuotation.Menu" },
          component: () => import("./views/peakweb/setting/settingPartialQuotation/SettingPartialQuotation.vue"),
        },
        {
          path: "partialPurchaseOrderSetting",
          name: "partialPurchaseOrderSetting",
          meta: { title: "Text_PartialPurchaseOrder.Menu" },
          component: () =>
            import("./views/peakweb/setting/settingPartialPurchaseOrder/SettingPartialPurchaseOrder.vue"),
        },
        {
          path: "documentReportUrlSetting",
          name: "documentReportUrlSetting",
          meta: { title: "Menu_Purchase_Order_Status_Update" },
          component: () => import("./views/peakweb/setting/settingDocumentReportUrl/SettingDocumentReportUrl.vue"),
        },
        {
          path: "createUserJournalSetting",
          name: "createUserJournalSetting",
          meta: { title: "Menu_Journal" },
          component: () => import("./views/peakweb/setting/settingCreateUserJournal/SettingCreateUserJournal.vue"),
        },
      ],
    },
    // Subscription
    {
      path: "/subscription",
      name: "subscription",
      meta: {
        title: "Title_Subscription",
        breadcrumb: [{ name: "Title_Subscription", linkName: "billingSetting" }, { name: "Extend_Package" }],
      },
      component: () => import("./views/peakweb/setting/billing/subscription/Subscription.vue"),
    },
    // Register Partner
    {
      path: "/register/partner",
      name: "register_partner",
      component: () => import("./views/registerPartnerPage/RegisterPartnerPage"),
      children: [
        {
          path: "accountant",
          name: "accountant_register_partner",
          component: () => import("./views/registerPartnerPage/contentRegister/Accountant"),
          meta: {
            title: "Meta_register",
            description:
              "เข้าสู่ระบบบัญชี PEAK ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft ปลอดภัย หากยังไม่มีบัญชี สมัครใช้งาน PEAK",
          },
          props(route) {
            return route.query || {};
          },
        },
        {
          path: "entrepreneur",
          name: "entrepreneur_register_partner",
          component: () => import("./views/registerPartnerPage/contentRegister/BusinessOwner"),
          meta: {
            title: "Meta_register",
            description:
              "เข้าสู่ระบบบัญชี PEAK ด้วยอีเมลและรหัสผ่าน หรือบัญชี Google, Microsoft ปลอดภัย หากยังไม่มีบัญชี สมัครใช้งาน PEAK",
          },
          props(route) {
            return route.query || {};
          },
        },
      ],
    },
    {
      path: "/investigate",
      name: "investigate",
      meta: {
        title: "investigate",
      },
      component: () => import("./views/peakweb/investigate/Investigate.vue"),
    },
    {
      path: "/downloadPeakMobile",
      name: "download_peak_mobile",
      meta: {
        title: "Download PEAK Mobile",
      },
      component: () => import("./views/peakMobile/DownloadPeakMobile.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (from && to && from.name !== to.name) {
      return { x: 0, y: 0 };
    }
  },
});
